module.exports = __webpack_public_path__ + "static/media/javascript.78589f2f.png";